import { useCallback, useEffect, useRef, useState } from 'react';
import Countdown from './Countdown';
import Events from './Events';
import Footer from './Footer';
import Intro from './Intro';
import Location from './Location';
import MusicToggle, { MusicToggleHandle } from './MusicToggle';
import './App.css';

function App() {
  const countdownRef = useRef<HTMLDivElement | null>(null);
  const musicToggleRef = useRef<MusicToggleHandle | null>(null);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const bodyOverflow = document.body.style.overflow;
    const htmlOverflow = document.documentElement.style.overflow;

    if (!hasStarted) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = bodyOverflow;
      document.documentElement.style.overflow = htmlOverflow;
    };
  }, [hasStarted]);

  const handleFooterClick = useCallback(() => {
    if (countdownRef.current) {
      countdownRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="App">
      <section className="App-section">
        <Intro
          onFooterClick={handleFooterClick}
          onPosterClick={() => {
            setHasStarted(true);
            musicToggleRef.current?.show();
            musicToggleRef.current?.play();
          }}
        />
      </section>
      <section className="App-section" ref={countdownRef}>
        <Countdown />
      </section>
      <section className="App-section">
        <Events />
      </section>
      <section className="App-section">
        <Location />
      </section>
      <section className="App-section App-section--tight">
        <Footer />
      </section>
      <MusicToggle ref={musicToggleRef} />
    </div>
  );
}

export default App;
